import * as React from 'react';
import { BaseTableHeadCell } from '../base-table-head-cell/base-table-head-cell';
import { EllipsisText } from '../../../../composites/ellipsis-text/ellipsis-text';
import { InfoTooltip } from '../../../info-tooltip/info-tooltip';
export var TableHeadCell = function (props) {
    var hideSeperator = props.hideSeperator || !!props.children === false;
    return (React.createElement(BaseTableHeadCell, { className: props.className, hideSeperator: hideSeperator, disabled: props.disabled },
        React.createElement(EllipsisText, null,
            React.createElement("div", { className: 'head-cell-content' }, props.children)),
        props.infoIcon ? React.createElement(InfoTooltip, { className: 'head-cell-info', text: props.infoIcon, relativeToBody: true, tooltipAlign: "left" }) : null));
};
//# sourceMappingURL=table-head-cell.js.map